package com.shadowings.gero.data.lessons.chapter8

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.shadowings.gero.data.lessons.buildVsoPhoneticKeyboardQuizzes
import com.shadowings.gero.data.lessons.buildVsoWordSelectionQuizzes
import com.shadowings.gero.data.repository.DatabaseRepositoryImpl
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_due_oggetti_alyn_1
import gero.composeapp.generated.resources.exp_content_due_oggetti_alyn_2
import gero.composeapp.generated.resources.exp_content_due_oggetti_nilo_1
import gero.composeapp.generated.resources.exp_content_due_oggetti_nilo_2
import gero.composeapp.generated.resources.exp_title_due_oggetti
import kotlin.random.Random

fun getDueOggettiContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_due_oggetti,
            content = Res.string.exp_content_due_oggetti_alyn_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_due_oggetti,
            content = Res.string.exp_content_due_oggetti_nilo_1,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_due_oggetti,
            content = Res.string.exp_content_due_oggetti_nilo_2,
            face = Faces.Happy,
            character = Characters.Nilo,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "O34-G36:D21-A2-Y3-A1-N35:N35:N35-V28-N35:N29-X1:W22",
                        rtl = false,
                        cart = false
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_due_oggetti,
            content = Res.string.exp_content_due_oggetti_alyn_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        )
    )
}

fun getDueOggettiQuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    verbs: List<Verb>,
    languageCode: String,
    verbSentences: List<SentenceOptions> = DatabaseRepositoryImpl.verbSentences
): List<IQuizContent> {
    val wordSelection = buildVsoWordSelectionQuizzes(
        soggettiCount = 1,
        oggettiCount = 2,
        random = Random,
        languageCode = languageCode,
        count = 8,
        verbSentences = verbSentences,
        words = words,
        verbs = verbs
    )
    val keyboardQuizzes = buildVsoPhoneticKeyboardQuizzes(
        soggettiCount = 1,
        oggettiCount = 2,
        random = Random,
        languageCode = languageCode,
        count = 2,
        verbSentences = verbSentences,
        words = words,
        verbs = verbs
    )
    return (wordSelection + keyboardQuizzes).shuffled()
}
